import { LayoutType, withLayout } from 'hocs/with-layout';

import { UnlinkedQrCode } from './unlinked-qr-code';

const WrappedNotFound = withLayout(
  LayoutType.WithOldNavAndFooter,
  UnlinkedQrCode,
);

export { WrappedNotFound as UnlinkedQrCode };
